var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrows2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 131.4 12.8",
    style: {
      enableBackground: "new 0 0 131.4 12.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000060729537839087261050000004406530268468073606_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.8368,
    y1: 6.388,
    x2: 131.3951,
    y2: 6.388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F1945"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5A365D"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.8,8.3c0,0,1.7,3.7,5.7,4.5c0,0,24.2-7.9,31.2-7.5c7,0.4,13.7,7.5,13.7,7.5s-8.3-11.6-12.2-12.5 C112.4-1.5,85,6.2,85,6.2s0.8,3.4,2,4.8c0,0-2.8-1.9-4.5-4.2L80.8,8.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180359650515504175640000010961585959590595493_",
    gradientUnits: "userSpaceOnUse",
    x1: -1341.0215,
    y1: 6.388,
    x2: -1290.4631,
    y2: 6.388,
    gradientTransform: "matrix(-1 0 0 1 -1290.4631 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F1945"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5A365D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180359650515504175640000010961585959590595493_)"
    },
    d: "M50.6,8.3c0,0-1.7,3.7-5.7,4.5 c0,0-24.2-7.9-31.2-7.5C6.7,5.6,0,12.8,0,12.8S8.3,1.2,12.2,0.2C19-1.5,46.4,6.2,46.4,6.2s-0.8,3.4-2,4.8c0,0,2.8-1.9,4.5-4.2 L50.6,8.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrows2);
export default __webpack_public_path__ + "static/media/Brows2.3ca083b48bc54bdf1e4833a10a19e7c3.svg";
export { ForwardRef as ReactComponent };